import React from "react";

const SocialIcon = ({ social, index }) => {
  return (
    <a
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-800 to-gray-700 
                hover:from-amber-600 hover:to-amber-400 
                border border-amber-500/30 
                flex items-center justify-center 
                transition-all duration-300 hover:scale-110 group"
      aria-label={social.name}
      style={{
        transitionDelay: `${index * 50}ms`,
        transform: `translateY(${Math.sin(index) * 5}px)`,
      }}
    >
      <span className="sr-only">{social.name}</span>
      <svg
        className="w-5 h-5 text-gray-300 group-hover:text-gray-900 transition-colors"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        {social.svgPath}
      </svg>

      {/* Animated glow effect */}
      <span className="absolute -inset-1 rounded-full bg-amber-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-md"></span>
    </a>
  );
};

export default SocialIcon;
